import ConditionBanner from '../../layouts/ConditionBanner.vue';
import Medicines from '../../Medicines.vue';
export default {
    components: {
        ConditionBanner,
    },
    data() {
        return {
            bannerTitle: 'Other Top Medications',
            conditionData: Medicines.data().medicines
        };
    },
};